import e from "react";
import { componentName as t } from "../../../utils/bem/index.js";
import "../../forms/InputText/InputText.js";
import { InputTextField as a } from "../../forms/InputText/InputTextField.js";
import { Button as r } from "../../buttons/Button/Button.js";
import { KASEYA as o } from "../../../constants/kaseya.js";
import { t as s } from "../../../i18/index.js";
function n(a) {
  var r = t("forgot-password", a.className),
    n = a.errorMessage,
    i = a.helpAndSupportLink,
    m = a.onSubmit,
    p = a.backToLoginLink,
    g = a.passwordSent;
  return e.createElement("div", {
    className: r
  }, e.createElement("div", {
    className: "public__background-container-bottom"
  }), e.createElement("div", {
    className: "public__background-container-top"
  }), e.createElement("div", {
    className: "public__logos-row"
  }, e.createElement("a", {
    href: a.brandUrl
  }, e.createElement("img", {
    src: a.brandLogo
  }))), g ? e.createElement(c, {
    backToLoginLink: p
  }) : e.createElement(l, {
    onSubmit: function onSubmit(e) {
      e.preventDefault(), m(new FormData(e.target).get("email"));
    },
    errorMessage: n,
    backToLoginLink: p
  }), e.createElement("div", {
    className: "public__footer"
  }, e.createElement("div", {
    className: "public__footer-logo"
  }, e.createElement("div", {
    className: "public__footer-logo-img"
  })), e.createElement("a", {
    className: "public__footer-link",
    target: "_blank",
    href: i
  }, s("help-and-support")), " | ", " ", o.COPYRIGHT));
}
function l(t) {
  var o = t.onSubmit,
    n = t.errorMessage,
    l = t.backToLoginLink;
  return e.createElement("form", {
    onSubmit: o,
    className: "forgot-password__panel"
  }, e.createElement("h1", {
    className: "forgot-password__title"
  }, s.title("forgot-password")), e.createElement("span", {
    className: "forgot-password__instructions"
  }, s("forgot-password-instructions-1"), e.createElement("br", null), s("forgot-password-instructions-2")), e.createElement(a, {
    className: "forgot-password__email",
    errorMessage: n,
    name: "email",
    label: s("email")
  }), e.createElement(r, {
    className: "forgot-password__reset",
    type: "submit",
    label: s("reset"),
    variant: "accent",
    size: "large"
  }), e.createElement("a", {
    className: "forgot-password__return-link",
    href: l
  }, s("back-to-login")));
}
function c(t) {
  var a = t.backToLoginLink;
  return e.createElement("div", {
    className: "forgot-password__panel forgot-password__sent"
  }, e.createElement("div", {
    className: "forgot-password__sent-icon"
  }), e.createElement("h1", {
    className: "forgot-password__sent-title"
  }, s("email-sent")), e.createElement("span", {
    className: "forgot-password__sent-text"
  }, s("password-reset-sent")), e.createElement("a", {
    className: "forgot-password__return-button-link",
    href: a
  }, e.createElement(r, {
    className: "forgot-password__return-button",
    type: "submit",
    label: s("back-to-login"),
    variant: "accent",
    size: "large"
  })));
}
n.defaultProps = {
  backToLoginLink: "/login",
  brandLogo: o.LOGO,
  brandUrl: o.URL,
  successMode: !1
}, n.displayName = n;
export { n as ForgotPassword };